import React, { useState, useEffect } from 'react';
import PhotoAlbum from "react-photo-album";
import "react-photo-album/styles.css";
import Navbar from "../components/Navbar";
import './art.css';


  const traditionalImages = [
    { src: '/images/artCarousel/traditional/a_window_to_the_future.jpg', alt: 'A Window to the Future', credit: 'A Window to the Future | (Watercolor & Colored Pencil on Paper)', width: 3487, height: 2640 },
    { src: '/images/artCarousel/traditional/wisterias_automaton.jpg', alt: "Wisteria's Automaton", credit: "Wisteria's Automaton | (Watercolor & Colored Pencil on Paper)", width: 3714, height: 2852 },
    { src: '/images/artCarousel/traditional/an_endless_sea.jpg', alt: 'An Endless Sea', credit: 'An Endless Sea | (Watercolor on Paper)', width: 3956, height: 2781 },
    { src: '/images/artCarousel/traditional/inktober_overgrown.jpg', alt: "Inktober: Overgrown", credit: "Inktober: Overgrown | Ink on Red Cardstock", width: 2634, height: 3421 },
    { src: '/images/artCarousel/traditional/inktober_pumpkin.jpg', alt: "Inktober: Pumpkin", credit: "Inktober: Pumpkin | Ink on Orange Cardstock", width: 3045, height: 2353 },
    { src: '/images/artCarousel/traditional/marie_antoinette.jpg', alt: "Marie Antoinette", credit: "Emilia Schüle as Marie Antoinette | Colored Pencil on Toned Paper", width: 1968, height: 2048 },
    { src: '/images/artCarousel/traditional/claudia.jpg', alt: "Claudia", credit: "Kirsten Dunst as Claudia | Colored Pencil on Toned Paper", width: 2068, height: 2068 },
    { src: '/images/artCarousel/traditional/grad_cap.jpg', alt: "Graduation Cap", credit: "Painted Graduation Cap", width: 2927, height: 2927 },
  ];

  const digitalImages = [
    { src: '/images/artCarousel/digital/rose.jpg', alt: 'Rosalia', credit: 'Rosalia (OC Portrait)', width: 2936, height: 3613 },
    { src: '/images/artCarousel/digital/maive.jpg', alt: 'Maive', credit: 'Maive (OC Portrait)', width: 2112, height: 2640 },
    { src: '/images/artCarousel/digital/james.jpg', alt: 'James', credit: 'James (Jamnesia Character Portrait)', width: 1842, height: 2302 },
    { src: '/images/artCarousel/digital/maia.jpg', alt: 'Maia', credit: 'Maia (OC Portrait)', width: 2394, height: 3256 },
    { src: '/images/artCarousel/digital/maive2.jpg', alt: 'Maive', credit: 'Maive (OC Portrait)', width: 2475, height: 3094 },
    { src: '/images/artCarousel/digital/lady_yin.jpg', alt: 'Lady Yin', credit: 'Lady Yin (Nezha Fanart)', width: 3200, height: 4000 },

    // Graphic Design
    { src: '/images/artCarousel/graphic_design/fencing_bear.jpg', alt: 'Fencing Bear', credit: 'Logo Design for UCLA Fencing | Drawn in Procreate, formatted in Adobe Photoshop)', width: 4000, height: 4000 },
    { src: '/images/artCarousel/graphic_design/nocturne_logo.jpg', alt: 'Nocturne Logo', credit: 'Logo Design for Nocturne Runway Collection | (Drawn in Procreate, edited in Adobe Illustrator)', width: 2640, height: 2112 },
  ];
    


  export default function Art() {

    const [activeTab, setActiveTab] = useState("traditional");
    const [selectedImage, setSelectedImage] = useState(null);
  
    // const filteredImages =
    //   activeTab === "traditional" ? traditionalImages : digitalImages;


      // Mechanism for closing the image after clicking to enlarge

      useEffect(() => {
        function handleKeyDown(e) {
          if (e.key === "Escape") {
            setSelectedImage(null);
          }
        }
      
        window.addEventListener("keydown", handleKeyDown);
      
        return () => {
          window.removeEventListener("keydown", handleKeyDown);
        };
      }, [setSelectedImage]);
  

  return (
    <div>
      <Navbar />
      <h1 className="header" style={{ fontFamily: 'Cormorant SC, serif', fontSize: '3.5rem' }}>Art</h1>
      <hr className="line" />

      <div className="gallery-page">
      {/* Buttons to Switch Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "traditional" ? "active" : ""}
            onClick={() => setActiveTab("traditional")}
          >
            traditional
          </button>
          <button
            className={activeTab === "digital" ? "active" : ""}
            onClick={() => setActiveTab("digital")}
          >
            digital
          </button>
        </div>

        <div className="gallery-grid">
        {activeTab === "traditional" ? (
        <PhotoAlbum
          layout="rows"
          photos={traditionalImages}
          targetRowHeight={450}
          spacing={15}
          defaultContainerWidth={1200}
          onClick={({ index }) => setSelectedImage(traditionalImages[index])}
        />
      ) : (
        <PhotoAlbum
          layout="rows"
          photos={digitalImages}
          targetRowHeight={500}
          spacing={15}
          defaultContainerWidth={1200}
          onClick={({ index }) => setSelectedImage(digitalImages[index])}
        />
      )}
         </div>

      {/* Click to Enlarge */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content">
            <div className="modal-wrapper" onClick={() => setSelectedImage(null)}>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="modal-image"
            />
            {selectedImage.credit && (
                <p className="modal-credit">{selectedImage.credit}</p>
              )}
            </div>
            </div>
          </div>
      )}
    </div>

      {/* Footer */}

      <div className="footer__container">
        <div className="websiteRights">
          <p>© MINYA 2025 | all rights reserved</p>
        </div>
      </div>

    </div>
  );
};